export const locale = {
    lang: "en",
    data: {
        TOOLBAR: {
            Help: "Open user manual",
            BrowserNotificationsTitle: "Browser notifications",
            BrowserNotificationsPromptBody:
                "If you continue, this browser will be registered for your user and you will receive Emma browser notifications across the app.",
            BrowserNotificationsEnabledBody:
                "Browser notifications are already enabled for your user. You can manage the current project from here.",
            BrowserNotificationsPermissionDenied:
                "Browser notifications are disabled in this browser. Re-enable them from your browser site settings for Emma to send alerts here.",
            BrowserNotificationsCurrentProject: "Current project",
            BrowserNotificationsProjectToggle: "Receive notifications in this project",
            BrowserNotificationsProjectStatusEnabled: "Notifications enabled in this project",
            BrowserNotificationsProjectStatusMuted: "Notifications muted in this project",
            BrowserNotificationsProjectEnabled: "Browser notifications enabled for this project.",
            BrowserNotificationsProjectMuted: "Browser notifications muted for this project.",
            BrowserNotificationsEnableAction: "Enable notifications",
            BrowserNotificationsSkip: "Not now",
            BrowserNotificationsNotConfigured: "Browser notifications are not configured in this environment.",
            BrowserNotificationsUnsupported: "This browser does not support push notifications.",
            BrowserNotificationsEnabled: "Browser notifications enabled.",
            BrowserNotificationsError: "The browser notification preference could not be updated.",
            BrowserNotificationHeadlineAlarm: "Critical alarm",
            BrowserNotificationHeadlineWarning: "Warning alarm",
            BrowserNotificationHeadlineSuccess: "Alarm cleared",
            BrowserNotificationHeadlineInfo: "Notification",
            BrowserNotificationFieldAlarm: "Alarm",
            BrowserNotificationFieldProject: "Project",
            BrowserNotificationFieldDevice: "Device",
        },
    },
};
